export default "__VITE_ASSET__Dkg1jIbB__"